import PropTypes from 'prop-types';
import DocumentUploadType from './documentUpload';
import ContractorLineItemType from './contractorLineItem';
import AssigneeType from './assignee';
import { AppointmentType } from './appointment';

const LaborSheetType = PropTypes.shape({
  id: PropTypes.number,
  quickbooks_reference: PropTypes.string,
  signed_document: DocumentUploadType,
  status: PropTypes.string,
  total: PropTypes.number,
  line_items: PropTypes.arrayOf(ContractorLineItemType),
  assignee: AssigneeType,
  appointment: AppointmentType,
});

export default LaborSheetType;



// WEBPACK FOOTER //
// ./client/app/shared/types/laborSheet.js